var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCapacitor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#53B9FF",
    points: "39.8626133 54.11456 0.310594133 93.71648 61.30624 154.894933 0 216.385067 39.4282667 256.004267 100.858027 194.497067 161.9552 255.5648 201.5072 215.962667"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#119EFF",
    points: "140.517333 154.896 100.859413 194.497067 161.956267 255.565867 201.508267 215.963733"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillOpacity: 0.2,
    fill: "#000000",
    points: "140.517333 154.896 100.859413 194.497067 116.125867 209.678933"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#53B9FF",
    points: "194.5696 100.985173 256 39.4779733 216.430933 0 155.018667 61.3835733 93.9165867 0.310993067 54.3645867 39.91296 216.0096 201.761067 255.5616 162.158933"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#119EFF",
    points: "115.36 100.986773 155.018667 61.3850667 93.9165867 0.312500267 54.3645867 39.9144533"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillOpacity: 0.2,
    fill: "#000000",
    points: "115.358933 100.985387 155.0176 61.3837867 139.7472 46.1978667"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapacitor);
export default __webpack_public_path__ + "static/media/capacitor.53018274b6ab2b7bfdeb6e06692fdadb.svg";
export { ForwardRef as ReactComponent };